














































import { Vue, Component } from "vue-property-decorator";
import Editor from "@/components/editor/index.vue";
import { FileItem } from "@/interface/editor";
import {
  upload,
  style,
  getGraceDetail,
  editGrace,
  uploadPercent,
  resetUploadPercent
} from "@/http/grace.api";
import Video from "@/components/editor/video";
import { imgList } from "@/views/20/data";
@Component({
  components: {
    Editor
  }
})
export default class GraceAdd extends Vue {
  formData: any = {
    title: "",
    companyName: "",
    content: ""
  };
  loading = false;
  rules = {
    title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
    companyName: [{ required: true, message: "单位不能为空", trigger: "blur" }],
    content: [{ required: true, message: "内容不能为空", trigger: "blur" }]
  };
  percent = 0;
  formatFileList(list: Array<FileItem>) {
    return list.reduce(
      (pre, cur) => {
        const { type, fileData } = cur;
        type === "image" ? pre.imgs.push(fileData) : pre.videos.push(fileData);
        return pre;
      },
      { imgs: [], videos: [] } as any
    );
  }
  getUploadParams(list: Array<FileItem>) {
    const { imgs, videos } = this.formatFileList(list);
    const formData = new FormData();
    if (imgs.length) {
      imgs.forEach((ele: any) => {
        formData.append("imgs", ele);
      });
    }
    if (videos.length) {
      videos.forEach((ele: any) => {
        formData.append("video", ele);
      });
    }
    return formData;
  }
  replaceSrc(
    text: string,
    fileSaveList: Array<FileItem>,
    uploadParams: FormData,
    res: any
  ) {
    let i = 0;
    let k = 0;
    console.log(fileSaveList, uploadParams);
    for (const [key, val] of uploadParams.entries()) {
      const data = fileSaveList.find(ele => ele.fileData === val);
      if (!data) break;
      if (key === "imgs") {
        console.log(res.imgs[i]);
        text = text.replace(
          new RegExp(data.localUrl),
          window.StaticUrl + res.imgs[i]
        );
        i++;
      } else {
        text = text.replace(new RegExp(data.localUrl), res.video[k]);
        k++;
      }
    }
    return text;
  }
  async getGraceDetail() {
    try {
      const res = await getGraceDetail({ id: this.$route.query.id });
      // this.data = res;
      for (const key in this.formData) {
        this.formData[key] = res[key];
      }
      (this.$refs.editor as any).text = this.formData.content;
    } catch (error) {
      console.log(error);
    }
  }
  mounted() {
    if (this.$route.query.id) {
      this.getGraceDetail();
    }
  }
  checkFormDataIsEmpty(data: FormData) {
    let i = 0;
    for (const iterator of data.entries()) {
      i++;
    }
    return !!i;
  }
  publish() {
    this.$route.query.id ? this.edit() : this.submitData();
  }
  uploadPercent() {
    const timer = setInterval(() => {
      this.percent += 1;
      if (this.percent >= 100) {
        clearInterval(timer);
        this.percent = 0;
      }
    }, 300);
  }
  async edit() {
    const ref = this.$refs.formData as any;
    const valid = await ref.validate();
    const data = { ...this.formData } as any;
    if (!valid) return;
    this.loading = true;
    data.id = this.$route.query.id;
    const editor = this.$refs.editor as any;
    const fileSaveList = [...editor.imgList, ...editor.videoList];
    // if (editor.imgList.length > 3) {
    //   this.$alert("最多只能有三张图片");
    //   return;
    // }
    // if (editor.videoList.length > 1) {
    //   this.$alert("最多只能有一段视频");
    //   return;
    // }
    const uploadParams = this.getUploadParams(fileSaveList);
    try {
      if (this.checkFormDataIsEmpty(uploadParams)) {
        // await resetUploadPercent();
        this.uploadPercent();
        const res: any = await upload(uploadParams);
        data.content = this.replaceSrc(
          data.content,
          fileSaveList,
          uploadParams,
          res
        );
      }
      // 找到封面
      const imgReg = /<img.*?(?:>|\/>)/gi;
      const allImg = data.content.match(imgReg);
      if (allImg.length) {
        data.imageUrl = allImg[0].split(window.StaticUrl)[1].slice(0, -2);
      }
      await editGrace(data);
      this.percent = 100;
      this.loading = false;
      await this.$alert("发布成功");
      this.$router.push("/person-center");
    } finally {
      this.loading = false;
      this.percent = 100;
    }
  }
  async submitData() {
    const ref = this.$refs.formData as any;
    const valid = await ref.validate();
    const data = { ...this.formData } as any;
    if (!valid) return;
    const editor = this.$refs.editor as any;
    this.loading = true;
    const fileSaveList = [...editor.imgList, ...editor.videoList];
    const uploadParams = this.getUploadParams(fileSaveList);
    try {
      // await resetUploadPercent();
      this.uploadPercent();
      const res: any = await upload(uploadParams);
      if (res && res.imgs.length) {
        data.imageUrl = res.imgs[0];
      }
      data.content = this.replaceSrc(
        data.content,
        fileSaveList,
        uploadParams,
        res
      );
      await style(data);
      this.percent = 100;
      this.loading = false;
      await this.$alert("发布成功");
      this.$router.push("/person-center");
    } finally {
      this.loading = false;
      this.percent = 100;
    }
    // console.log(this.formData);
  }
}
